import { Dolan, View } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { weakMapMemoize } from '@reduxjs/toolkit';
import refreshViewVariables from './refreshViewVariables';

const refreshViews = weakMapMemoize((views: View[]) => views.map(refreshViewVariables));

/**
 * Ensures that all data variables in the given DOLAN structure are up-to-date.
 * Utilizes caching so that it is fast to call multiple times for DOLAN without
 * significant changes.
 *
 * This impelmentation is based on the old `updateDolanVariables` from AngularJS.
 */
export default function refreshDolanVariables(dolan: Dolan): Dolan {
  const refreshedViews = refreshViews(dolan.views);
  return refreshedViews === dolan.views ? dolan : { ...dolan, views: refreshedViews };
}
